import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '数据关系',
    textProp: 'algTitle',
    type: 'BD_RELATION',
}
